<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        title="电站列表"
        :data="tableData"
        :columns="tableColumns"
        :selectable="true"
        :rowSelectable="() => true"
        :selectOnIndeterminate="false"
        operateFixedType="right"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())"
        @selection-change="selectionChange">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button
              v-rbac="'operation:price:rake:export'"
              type="plain"
              @click="handleExportData">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-drawer
      :show.sync="showDrawer"
      title="抽成费用策略"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button
              style="margin-left: 8px"
              :type="btn.type"
              v-if="btn.enabled()"
              :key="i"
              @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <AddOrEdit
          :selectedRows="selectedRows"
          :currentRow="currentRow"
          :operateType="operateType"
          ref="addOrEdit"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import AddOrEdit from './AddOrEdit.vue';
  import { offlineExport, code } from '@/utils';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { commissionStrategy, directPage } from '@/service/apis';

  export default {
    name: 'RoyaltyStrategyList',
    components: {
      AddOrEdit,
    },
    data() {
      return {
        operateType: '',
        currentRow: null,
        selectedRows: [],
        showDrawer: false,
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '提交',
            enabled: () => true,
            handler: () => {
              this.$refs.addOrEdit &&
                this.$refs.addOrEdit.submitForm(() => {
                  this.showDrawer = false;
                  this.searchTableList();
                });
            },
          },
        ],
        tableData: [],

        tableOperateButtons: [
          {
            enabled: () => code('operation:price:rake:edit'),
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doEdit(row);
                  }}>
                  编辑
                </ykc-button>
              );
            },
          },
          {
            enabled: () => true,
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doViewHistory(row);
                  }}>
                  查看历史配置申请
                </ykc-button>
              );
            },
          },
        ],
        tableColumns: [
          { label: '电站编码', prop: 'stationCode', minWidth: '200px', fixed: 'left' },
          {
            label: '电站名称',
            prop: 'stationName',
            minWidth: '200px',
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.stationName} placement="top-start">
            //         <span>{row.stationName ?? '--'}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          {
            label: '归属商家',
            prop: 'stationOperatorName',
            minWidth: '200px',
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.stationOperatorName} placement="top-start">
            //         <span>{row.stationOperatorName ?? '--'}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          {
            label: '状态',
            prop: 'status',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { status } }) => {
                const statusText = {
                  0: '未配置',
                  1: '已配置',
                }[status];
                return statusText || '一';
              },
            },
          },
          {
            label: '物业电费抽成',
            prop: 'powerRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { status, powerRateType, powerRate } }) => {
                if (status === '0') return '————';
                const powerRateTypeName = {
                  1: `度数：${powerRate}元/度`,
                  2: `折扣：金额${powerRate}%`,
                  3: `小时：${powerRate}元/时`,
                  4: `次数：${powerRate}元/次`,
                }[powerRateType];
                return powerRateTypeName || '————';
              },
            },
          },
          {
            label: '物业服务费抽成',
            prop: 'serviceRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { status, serviceRateType, serviceRate } }) => {
                if (status === '0') return '————';
                const serviceRateTypeName = {
                  1: `度数：${serviceRate}元/度`,
                  2: `折扣：金额${serviceRate}%`,
                  3: `小时：${serviceRate}元/时`,
                  4: `次数：${serviceRate}元/次`,
                }[serviceRateType];
                return serviceRateTypeName || '————';
              },
            },
          },
          {
            label: '分成方1服务费抽成',
            prop: 'partner1ServiceRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner1ServiceRateType, partner1ServiceRate } }) => {
                const text = {
                  1: `度数：${partner1ServiceRate}元/度`,
                  2: `折扣：金额${partner1ServiceRate}%`,
                  3: `小时：${partner1ServiceRate}元/时`,
                  4: `次数：${partner1ServiceRate}元/次`,
                }[partner1ServiceRateType];
                return text || '————';
              },
            },
          },
          {
            label: '分成方1年费抽成',
            prop: 'partner1YearRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner1YearRate } }) => {
                return partner1YearRate ? `${partner1YearRate}元/年` : '————';
              },
            },
          },
          {
            label: '分成方2服务费抽成',
            prop: 'partner2ServiceRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner2ServiceRateType, partner2ServiceRate } }) => {
                const text = {
                  1: `度数：${partner2ServiceRate}元/度`,
                  2: `折扣：金额${partner2ServiceRate}%`,
                  3: `小时：${partner2ServiceRate}元/时`,
                  4: `次数：${partner2ServiceRate}元/次`,
                }[partner2ServiceRateType];
                return text || '————';
              },
            },
          },
          {
            label: '分成方2年费抽成',
            prop: 'partner2YearRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner2YearRate } }) => {
                return partner2YearRate ? `${partner2YearRate}元/年` : '————';
              },
            },
          },
          {
            label: '分成方3服务费抽成',
            prop: 'partner3ServiceRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner3ServiceRateType, partner3ServiceRate } }) => {
                const text = {
                  1: `度数：${partner3ServiceRate}元/度`,
                  2: `折扣：金额${partner3ServiceRate}%`,
                  3: `小时：${partner3ServiceRate}元/时`,
                  4: `次数：${partner3ServiceRate}元/次`,
                }[partner3ServiceRateType];
                return text || '————';
              },
            },
          },
          {
            label: '分成方3年费抽成',
            prop: 'partner3YearRate',
            minWidth: '200px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { partner3YearRate } }) => {
                return partner3YearRate ? `${partner3YearRate}元/年` : '————';
              },
            },
          },
          { label: '修改人', prop: 'modifiedAccount', minWidth: '200px' },
          { label: '修改时间', prop: 'modifiedTime', minWidth: '200px' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          stationName: '',
          stationOperatorId: '',
          status: '',
        },
        OperatorListData: [], // 归属商户
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'stationOperatorId',
            label: '归属商家',
            placeholder: '请输入归属商家',
            data: this.OperatorListData,
            remote: true,
          },
        ];
      },
    },
    created() {
      this.searchTableList();
      this.requestOperatorList();
    },
    methods: {
      requestOperatorList() {
        directPage.userOperatorList({ keyword: '' }).then(res => {
          // eslint-disable-next-line no-unused-vars
          this.OperatorListData = (res || []).map(({ operatorId, name }) => ({
            name,
            id: String(operatorId),
          }));
        });
      },
      handleExportData() {
        offlineExport(
          {
            downloadType: 'station_price_export',
            jsonNode: {
              downloadKey: 'commission_price_list',
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      doEdit(row) {
        console.log('row', row);
        this.operateType = 'single';
        this.currentRow = row;
        this.showDrawer = true;
      },
      /** 撤销最新配置申请 */
      doRevoke(row) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '确认撤销该电站的最新配置申请？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .revoke({ stationId: row.stationId })
              .then(() => {
                this.$message.success('撤销成功');
                done();
                this.searchTableList();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
      /** 查看历史配置申请 */
      doViewHistory(row) {
        this.$router.push({
          path: '/operationCenter/priceManage/royaltyStrategyApply',
          query: { stationName: row.stationName },
        });
      },
      searchTableList() {
        const data = {
          ...this.searchParams,
          size: this.pageInfo.pageSize,
          current: this.pageInfo.pageIndex,
        };
        commissionStrategy.queryForPage(data).then(res => {
          this.tableData = res.records;
          this.pageInfo.total = res.total;
          this.pageInfo.pageIndex = res.current;
        });
      },

      handleBatchSet() {
        if (this.selectedRows.length > 0) {
          this.operateType = 'multiple';
          this.showDrawer = true;
        } else {
          this.$message.warning('请选择数据');
        }
      },

      /** 点击清空查询按钮 */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },

      /** 点击查询按钮 */
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      onAddDrawerClose(done) {
        done();
      },
      /** 分页 change 事件监听器 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /** 点击抽屉取消按钮 callback */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
          },
        });
      },
      /** 分页 size  change  事件监听器 */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /** 获取勾选id */
      selectionChange(selection) {
        this.selectedRows = [...selection];
      },
    },
  };
</script>

<style lang="scss" scoped></style>
